// pages/Dashboard.jsx
import CancellationPolicy from "../../components/home/policyComponents/CancellationPolicy";
import HomeLayout from "../../components/home/HomeLayout";

export default function Dashboard() {
  return (
    <HomeLayout>
      <CancellationPolicy />
    </HomeLayout>
  );
}
